export var TicketSaleStatus;
(function (TicketSaleStatus) {
    TicketSaleStatus[TicketSaleStatus["SALE_SCHEDULED"] = 0] = "SALE_SCHEDULED";
    TicketSaleStatus[TicketSaleStatus["SALE_STARTED"] = 1] = "SALE_STARTED";
    TicketSaleStatus[TicketSaleStatus["SALE_ENDED"] = 2] = "SALE_ENDED";
})(TicketSaleStatus || (TicketSaleStatus = {}));
